export const employeeName = (employee: Employee) =>
  `${
    employee.nickname || employee.Contact.Person.firstName.trim()
  } ${employee.Contact.Person.lastName.trim()}`;

export const employeeNameWithNickname = (employee: Employee) =>
  `${employee.Contact.Person.firstName.trim()}${
    employee.nickname ? ` "${employee.nickname}" ` : ' '
  }${employee.Contact.Person.lastName.trim()}`;

export const employeeNameFromSimpleContact = (simpleContact: {
  nickname: string | null;
  firstName: string | null;
  lastName: string | null;
}) => `${simpleContact.nickname || simpleContact.firstName} ${simpleContact.lastName}`;

export const employeeNameFromId = (employees: Array<Employee>, employeeId: number) => {
  const employee = employees.find((emp) => emp.employeeId === employeeId);
  return employee ? employeeName(employee) : '';
};
